import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chargeBalance, ChargeRequest, ChargeResponse } from '@/api/wallet';

export const useCharge = () => {
  const queryClient = useQueryClient();

  return useMutation<ChargeResponse, Error, ChargeRequest>({
    mutationFn: chargeBalance,
    onSuccess: () => {
      // チャージ成功時に残高と決済履歴を再取得
      queryClient.invalidateQueries({ queryKey: ['balance'] });
      queryClient.invalidateQueries({ queryKey: ['transactionHistory'] });
    },
  });
};
